import Button from '@mui/material/Button';
import IconSearch from '@ui/icons/imaterial/base/Search.svg';
import React from 'react';

import useStyles from './SearchInput.style';

interface SearchInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  onValueChange: (value: string) => void; 
  onSort?: () => void;
  style?: React.CSSProperties;
}

const SearchInput: React.FC<SearchInputProps> = (props) => {
  const { onValueChange, onSort, className, style, ...rest } = props;
  const { classes, cx } = useStyles();
  
  return (
    <div
      className={cx(classes.inputWrapper, className)}
      style={style}
    >
      <input
        {...rest}
        className={classes.input}
        onChange={(e) => onValueChange(e.target.value)}
      />

      <IconSearch className={classes.inputIcon} />

      {onSort && (
        <Button
          size="small"
          variant="outlined"
          color="primary"
          className={classes.button}
        >
          Sort
        </Button>
      )}
    </div>
  );
};

export default SearchInput;
